var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconVolumeMuted = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "m18.9 17.9-1.415 1.414L10 11.828V19l-6-6H1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h3l.586-.586L1.222 3.05l1.414-1.414zM16.822 3.176a8.92 8.92 0 0 1 1.785 11.603l-1.457-1.456a6.9 6.9 0 0 0 .82-3.972 6.95 6.95 0 0 0-2.562-4.76zM6 7.828 4.829 9H2v2h2.828L8 14.172V9.829L5.999 7.828zm7.994-1.82a4.97 4.97 0 0 1 1.66 5.817l-1.657-1.658q.004-.083.004-.167a2.92 2.92 0 0 0-1.448-2.552l1.44-1.44zM10 1v5.172L7.414 3.586z"
})));
export default SvgIconVolumeMuted;